<template>
  <Modal :name="'city'" :type="'city'" :style="{'z-index': cityModalCoords['z-index']}">
    <DesktopSelectCity/>
  </Modal>
  <SelectCityPopup />
</template>

<script>

import { defineAsyncComponent } from 'vue'
import { cityModalCoords } from '~/js/stores/modal.js'

import { mapStores } from '@nanostores/vue'
import Modal from '~/library.blocks/modal/modal.vue'
import SelectCityPopup from '~/common.blocks/select-city-popup/select-city-popup.vue'

const DesktopSelectCity = defineAsyncComponent(
  () => import('~/common.blocks/desktop-select-city/desktop-select-city.vue'),
)

export default {
  components: {
    DesktopSelectCity,
    Modal,
    SelectCityPopup,
  },
  setup() {
    return { ...mapStores({ cityModalCoords }) }
  },
  data() {
    return {
      searchWord: '',
    }
  },
  computed: {
    inputParams() {
      return {
        placeholder: 'Введите название города',
        value: this.searchWord,
      }
    },
  },
  watch: {
    searchWord(value) {
      this.search(value)
    },
  },
  methods: {
    saveWord(value) {
      this.searchWord = value
    },
    clear() {
      this.searchWord = ''
    },
  },
}
</script>
